import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CryptojsService {

  constructor() {
  }

  passCrypt: string;

  fillPassCrypt(doc: string) {
    this.passCrypt = `${environment.SEGURIDAD.CRYPT_SECRET}${doc}`;
    this.passCrypt = this.passCrypt.length > 16 ? this.passCrypt.substring(0, this.passCrypt.length - 1) : this.passCrypt.padEnd(16, '0');
  }

  encrypt(txt: any) {
    this.fillPassCrypt(txt.afiliado.numeroDocumento.toString());
    const _KEY = CryptoJS.enc.Utf8.parse(this.passCrypt);
    const _IV = CryptoJS.enc.Utf8.parse(this.passCrypt);
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(txt), _KEY, {
        keySize: 16,
        iv: _IV,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }

  decrypt(txt: any, txtEnc: any): any {
    this.fillPassCrypt(txt.numeroDocumento.toString());
    const _KEY = CryptoJS.enc.Utf8.parse(this.passCrypt);
    const _IV = CryptoJS.enc.Utf8.parse(this.passCrypt);
    return JSON.parse(CryptoJS.AES.decrypt(
      txtEnc, _KEY, {
        keySize: 16,
        iv: _IV,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8));
  }

  async encryptAES256Hex(message: string): Promise<string> {
    const keyHexa = environment.PQR_SFS_KEY;
    const ivHexa = environment.PQR_SFS_IV;

    const encrypted = CryptoJS.AES.encrypt(message, CryptoJS.enc.Hex.parse(keyHexa), {
      iv: CryptoJS.enc.Hex.parse(ivHexa),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const encryptedHexa = encrypted.toString(CryptoJS.format.Hex);

    return encryptedHexa;
  }
}
